import { openSpotlight } from '@mantine/spotlight';

import { publicConfig } from '@public-config';

import { CompanyProfile, Component, Project, SearchHit } from 'models';

import { ApiService } from 'services/ApiService';
import { InternalTrackingService } from 'services/InternalTrackingService';

import { SpotlightType } from '@/endpoints/spotlight';
import { IndustrySubcategory } from '@/payload-types';

const SpotlightService = {
    swr: {
        search: (query: string, include: SpotlightType[] = [], limit?: number) =>
            `/spotlight?search=${query}&include=${include.join(',')}${limit ? `&limit=${limit}` : ''}`,
    },

    search: async (query: string, include?: SpotlightType[], limit?: number) => {
        const searchParams = new URLSearchParams({
            search: query,
        });

        if (include) {
            searchParams.append('include', include.join(','));
        }

        if (limit) {
            searchParams.append('limit', limit.toString());
        }

        return ApiService.get<{
            companies: SearchHit<CompanyProfile>[];
            components: SearchHit<Component>[];
            projects: Project[];
            referenceDesigns: Project[];
            industrySubcategories: IndustrySubcategory[];
        }>(`${publicConfig.urls.api}/spotlight?${searchParams.toString()}`);
    },

    open: () => {
        InternalTrackingService.track('spotlight.open');

        openSpotlight();
    },
};

export { SpotlightService };
